export const PageViews = {
  // Registries landing — overview tab
  RegistriesOverview: 'RegistriesOverview',
  // Legacy Registries Discover Page (aka Global Search)
  RegistriesDiscoverLegacy: 'RegistriesDiscoverLegacy',
  // Registries landing — discover tab, per entity type
  RegistriesDiscoverRegistries: 'RegistriesDiscoverRegistries',
  RegistriesDiscoverCollections: 'RegistriesDiscoverCollections',
  RegistriesDiscoverVersions: 'RegistriesDiscoverVersions',
  // Registry detail page — tabs
  RegistriesDetails: 'RegistriesDetails',
  // Registry settings page
  RegistriesSettings: 'RegistriesSettings',
  // Artifact panel — versions list view
  ArtifactMembershipOverview: 'ArtifactMembershipOverview',
  ArtifactCollectionOverviewCard: 'ArtifactCollectionOverviewCard',
  ArtifactCollectionMetadata: 'ArtifactCollectionMetadata',
  ArtifactCollectionVersions: 'ArtifactCollectionVersions',
  ArtifactCollectionAutomations: 'ArtifactCollectionAutomations',
  ArtifactCollectionVersionMetrics: 'ArtifactCollectionVersionMetrics',
  // Artifact panel — individual version tabs
  ArtifactVersions: 'ArtifactVersions',
  ArtifactMetadata: 'ArtifactMetadata',
  ArtifactFiles: 'ArtifactFiles',
  ArtifactUsage: 'ArtifactUsage',
  ArtifactLineage: 'ArtifactLineage',
} as const;

export type PageView = (typeof PageViews)[keyof typeof PageViews];
